import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './48404219cb10939c86e5daacfa7d535fffaba81d8e00b9fd9aab9f417871c5f2.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import { ToolbarProvider } from './a160cf879b7cab120bf814e64f156f70cee237e5ec6d1ada4eef9b879e36d9b6.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/fc7c2512fc1249f4837f2cb1f271d18191fa6aebd32c5f03023614c2b76711ef.cfe-internal.js';
import useId from '../../hooks/useId/df6d0ff48c086d34ec4e3589a05e8dd99a305947cee007fa9f94a6dd07ae8d17.cfe-internal.js';

var _excluded = ["children", "defaultSelectedIndex", "selectedIndex", "onSelectedIndexChange", "className", "id", "data-testid"];
var Toolbar = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$defaultSelectedI = _ref.defaultSelectedIndex,
    defaultSelectedIndex = _ref$defaultSelectedI === void 0 ? 0 : _ref$defaultSelectedI,
    externalSelectedIndex = _ref.selectedIndex,
    onSelectedIndexChange = _ref.onSelectedIndexChange,
    className = _ref.className,
    externalId = _ref.id,
    dataTestId = _ref['data-testid'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useControllableState = useControllableState(defaultSelectedIndex, onSelectedIndexChange, externalSelectedIndex),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    selectedIndex = _useControllableState2[0],
    setSelectedIndex = _useControllableState2[1];
  var toolbarId = useId(externalId);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    id: toolbarId,
    className: classNames(className, styles.toolbar),
    "data-testid": dataTestId
  }), /*#__PURE__*/React__default.createElement(ToolbarProvider, {
    value: {
      selectedIndex: selectedIndex,
      setSelectedIndex: setSelectedIndex,
      id: toolbarId,
      rootDataTestId: dataTestId
    }
  }, children));
});

export { Toolbar as default };
